import _get from 'lodash/get';
import { contactSelectors } from '@lifesize/nucleus';

const getStartCallModalContact = (state) => {
  // Check if an existing contact has been selected
  const contactUuid = getContactUuid(state);
  if (contactUuid) return contactSelectors.getContactByUuidGenerator(state)(contactUuid) || {};
  // Return custom dial contact if it has been selected, or empty object
  return getCustomContact(state) || {};
};

const getContactUuid = state => _get(state, 'app.startCallModal.contactUuid');
const getCustomContact = state => _get(state, 'app.startCallModal.customContact');

export default {
  getStartCallModalContact
};
